import { createContext, useContext, useState } from "react";

const UserContext = createContext();
export const useUser = () => useContext(UserContext);

export function UserProvider({ children }) {
  const [xp, setXp] = useState(0);
  const [level, setLevel] = useState(1);
  const [badges, setBadges] = useState([]);
  const [progress, setProgress] = useState({}); // video progress
  const [avatar, setAvatar] = useState("/avatar1.png");

  const addXP = (amount) => {
    const newXP = xp + amount;
    setXp(newXP);
    setLevel(Math.floor(newXP / 100) + 1);
  };

  return (
    <UserContext.Provider
      value={{
        xp,
        level,
        badges,
        setBadges,
        progress,
        setProgress,
        avatar,
        addXP,
        setAvatar,
      }}
    >
      {children}
    </UserContext.Provider>
  );
}
